var styles = {
  "Header": "Online-Store-UI-Header_yeh58",
  "show": "Online-Store-UI-Header--show_70g41",
  "Interior": "Online-Store-UI-Header__Interior_zjkir"
};

export { styles as default };
